import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  height: 100%;
  min-height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  background-color: rgba(0, 0, 0, 0.72);

  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 0;

  cursor: default;
`;

export const Window = styled.div`
  position: relative;
  background-color: rgba(255, 255, 255, 0.74);
  padding: 2.5rem;
  border-radius: 1.6rem;
  z-index: 7;

  width: 86%;

  display: flex;
  flex-direction: column;

  align-items: center;
  justify-content: center;

  @media only screen and (min-width: 768px) {
    max-width: 51.9rem;
  }
`;

export const Close = styled.div`
  position: absolute;
  top: -15px;
  right: -5px;
  background-color: #f8f8f8;
  width: 3.1rem;
  height: 3.1rem;
  border-radius: 50%;
  z-index: 14;

  display: flex;
  flex-direction: column;

  align-items: center;
  justify-content: center;

  font-family: Roboto;
  font-size: 1.8rem;
  font-style: normal;
  font-weight: 700;
  line-height: 2.1rem;
  letter-spacing: 0em;
  text-align: center;
  color: ${({ theme }) => theme.colors.SECONDARY};

  :hover {
    cursor: pointer;
  }
`;

export const Button = styled.button`
  border-radius: 0.4rem;
  background-color: ${({ theme }) => theme.colors.PRIMARY};
  padding: 0.9rem 2.4rem;
  margin-top: 1.8rem;
  border: none;

  font-size: 1.4rem;
  font-style: normal;
  font-weight: 700;
  line-height: 1.8rem;
  letter-spacing: 0em;
  text-align: center;
  color: ${({ theme }) => theme.colors.WHITE};

  :hover {
    cursor: pointer;
  }

  @media only screen and (min-width: 768px) {
    margin-top: 2.1rem;
  }
`;
